export const USER_TYPES = {
  GUEST: "Guest",
  HOST: "Host",
  SUB_HOST: "SubHost",
};
